import type { IWlTransactionPageApi } from '@/types/wlTransaction';

export class WlTransactionItem {
    public amount: string;
    public availableBalance: string;
    public betInternalId: number;
    public createdAt: string;
    public description: string | null;
    public extra: string | null;
    public id: number;
    public operationId: number;
    public platformId: number;
    public processedAt: string | null;
    public processingStartedAt: string | null;
    public statusId: number;
    public toolUserId: number;
    public typeId: number;
    public updatedAt: string;
    public userCurrencyId: number;
    public userLogin: string;

    constructor(data: IWlTransactionPageApi) {
        this.id = data.id;
        this.createdAt = data.created_at;
        this.updatedAt = data.updated_at;
        this.processingStartedAt = data.processing_started_at;
        this.processedAt = data.processed_at;
        this.typeId = data.type_id;
        this.operationId = data.operation_id;
        this.toolUserId = data.tool_user_id;
        this.userLogin = data.user_login;
        this.platformId = data.tool_user_platform_id;
        this.userCurrencyId = data.user_currency_id;
        this.betInternalId = data.bet_internal_id;
        this.statusId = data.status_id;
        this.amount = data.amount;
        this.availableBalance = data.available_balance;
        this.description = data.description;
        this.extra = data.extra;
    }
}
